import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '~/context/registration';

import { setTermClauses } from '~/services/registration';

import {
  Container,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import { fetchTermClauses } from '~/services/options';
import { fetchCampaignContext } from '~/services/registration';
import { Loading } from '~/shared/components/Loading';
import { otherTypeCodes } from '~/shared/config';
import parse from 'html-react-parser';

interface ClauseOption {
  id: number;
  category: string;
  template: string;
  agree: boolean;
}

export const TermsOfService = ({}: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [clauseOptions, setClauseOptions] = useState<ClauseOption[]>([]);
  const [clauseIndex, setClauseIndex] = useState(0);
  const history = useHistory();

  const getTermClauseOptions = async () => {
    const resp = await fetchTermClauses();
    console.log('resp: ', resp);
    const opts = resp.map((opt) => {
      return {
        id: opt.id,
        category: opt.category,
        template: opt.template,
        agree: false,
      };
    });
    setClauseOptions(opts);
    setLoading(false);
  };

  useEffect(() => {
    getTermClauseOptions();
  }, []);

  if (loading) {
    return <Loading />;
  }

  const disableNext = clauseOptions.filter((x) => !x.agree).length > 0;
  const clause = clauseOptions[clauseIndex];

  return (
    <Container>
      <Form>
        <Row className='justify-content-center py-5'>
          <Col md='8'>
            <div className='text-center'>
              <h3>Terms of Service</h3>
              <p>
                We maintain “Our Advantage” and status as a trusted 501(c)(3)
                nonprofit because we adhere to federal and state guidelines for
                charitable fundraising. Here’s what you, your fundraising
                volunteers, and campaign supporters need to know about
                fundraising for Help Hope Live to enjoy these benefits.
              </p>
            </div>

            {clauseOptions.map((opt, i) => {
              return (
                <Card
                  key={i}
                  className='box-shadow my-5'
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CardBody>
                    <FormGroup check className='mb-3'>
                      <FormGroup key={i}>
                        <h2>{i + 1}</h2>
                        <Label>{opt?.category}</Label>
                        {opt ? parse(opt.template) : null}
                      </FormGroup>
                    </FormGroup>
                  </CardBody>
                </Card>
              );
            })}
          </Col>
        </Row>
      </Form>
    </Container>
  );
};
